(() => {
  function initFeaturedCollectionCarousels() {
    const carousels = document.querySelectorAll('[data-featured-carousel]');
    if (!carousels.length) return;

    carousels.forEach((carousel) => {
      if (carousel.dataset.carouselReady === 'true') return;
      carousel.dataset.carouselReady = 'true';

      const viewport = carousel.querySelector('[data-carousel-viewport]');
      const track = carousel.querySelector('[data-carousel-track]');
      const slides = Array.from(carousel.querySelectorAll('[data-carousel-slide]'));
      const section = carousel.closest('.featured-collection');
      const nav = section?.querySelector('[data-carousel-nav]');
      const prevButton = section?.querySelector('[data-carousel-prev]');
      const nextButton = section?.querySelector('[data-carousel-next]');

      if (!viewport || !track || !slides.length) return;

      let isPointerDown = false;
      let dragStarted = false;
      let startX = 0;
      let startScrollLeft = 0;
      let suppressClick = false;

      function getGap() {
        const styles = window.getComputedStyle(track);
        return parseFloat(styles.columnGap || styles.gap || 0) || 0;
      }

      function getStepSize() {
        const firstSlide = slides[0];
        if (!firstSlide) return viewport.clientWidth * 0.8;
        return firstSlide.getBoundingClientRect().width + getGap();
      }

      function updateControls() {
        if (!nav || !prevButton || !nextButton) return;

        const maxScroll = viewport.scrollWidth - viewport.clientWidth;
        const canScroll = maxScroll > 6;

        nav.hidden = !canScroll;

        if (!canScroll) return;

        prevButton.disabled = viewport.scrollLeft <= 4;
        nextButton.disabled = viewport.scrollLeft >= maxScroll - 4;
      }

      function scrollByStep(direction) {
        viewport.scrollBy({
          left: getStepSize() * direction,
          behavior: 'smooth'
        });
      }

      if (prevButton) {
        prevButton.addEventListener('click', () => {
          scrollByStep(-1);
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          scrollByStep(1);
        });
      }

      viewport.addEventListener('scroll', updateControls, { passive: true });
      window.addEventListener('resize', updateControls);
      window.addEventListener('load', updateControls);

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(() => updateControls());
        observer.observe(viewport);
        observer.observe(track);
      }

      viewport.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch') return;
        if (event.button !== 0) return;

        isPointerDown = true;
        dragStarted = false;
        startX = event.clientX;
        startScrollLeft = viewport.scrollLeft;

        viewport.classList.add('is-dragging');
      });

      window.addEventListener('pointermove', (event) => {
        if (!isPointerDown) return;

        const deltaX = event.clientX - startX;

        if (Math.abs(deltaX) > 4) {
          dragStarted = true;
        }

        viewport.scrollLeft = startScrollLeft - deltaX;
      });

      function endDrag() {
        if (!isPointerDown) return;

        isPointerDown = false;
        viewport.classList.remove('is-dragging');

        if (dragStarted) {
          suppressClick = true;
          window.setTimeout(() => {
            suppressClick = false;
          }, 120);
        }
      }

      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);
      window.addEventListener('mouseleave', endDrag);

      track.addEventListener(
        'click',
        (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );

      carousel.classList.add('is-animate-ready');

      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              carousel.classList.add('is-in-view');
              observer.unobserve(entry.target);
            });
          },
          {
            threshold: 0.18,
            rootMargin: '0px 0px -8% 0px'
          }
        );

        revealObserver.observe(carousel);
      } else {
        carousel.classList.add('is-in-view');
      }

      updateControls();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFeaturedCollectionCarousels, { once: true });
  } else {
    initFeaturedCollectionCarousels();
  }

  document.addEventListener('shopify:section:load', initFeaturedCollectionCarousels);
})();